import { CONTACT } from "@/lib/constants";

export function FooterLegal() {
  return (
    <div className="text-center space-y-2">
      <p className="text-sm text-muted-foreground">
        &copy; {new Date().getFullYear()} RivalTrack. All rights reserved.
      </p>
      <a 
        href={`mailto:${CONTACT.support}`}
        className="text-sm text-muted-foreground hover:text-primary transition-colors"
      >
        {CONTACT.support}
      </a>
    </div>
  );
}